module.exports = __webpack_public_path__ + "img/e2.7717b6d7.png";